import { Collapse } from "@material-ui/core";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";
import React from "react";
import { useToggleState } from "utils/hooks";

export const DetailsSection = ({ title, children }) => {
  const [expanded, , , toggleExpand] = useToggleState(true);

  return (
    <div className="tw-rounded-[12px] tw-border tw-border-[#ccc3fa] tw-bg-white tw-shadow-[0px_3px_1px_0px_rgba(0,0,0,0.12)]">
      <div
        className="tw-flex tw-items-center tw-justify-between tw-py-[16px] tw-px-[8px] tw-pl-[24px] tw-gap-[8px] tw-cursor-pointer tw-select-none"
        onClick={toggleExpand}
      >
        <div className="tw-font-medium tw-text-[1rem] tw-leading-normal tw-text-[#272522]">
          {title}
        </div>

        <ArrowDropDownRoundedIcon
          className={expanded ? "[transform:rotate(180deg)]" : ""}
        />
      </div>

      <Collapse in={expanded}>
        <div className="tw-border-t-2 tw-border-solid tw-border-0 tw-border-t-[#e7e6e4] tw-p-[24px]">
          {children}
        </div>
      </Collapse>
    </div>
  );
};
